import { Component, effect, inject } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { HeaderComponent } from '../../atoms/header/header.component';
import { InputTextModule } from 'primeng/inputtext';
import { NgClass, NgIf } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { BaseListComponent } from '../../organisms/base-list/base-list.component';
import { TableListActionsComponent } from '../table-list-actions/table-list-actions.component';
import { TableCaptionComponent } from '../table-list-caption/table-list-caption.component';
import { MaskComponent } from '../../organisms/mask/mask.component';
import { RoleStore } from '../../../stores/role/role.state';
import { Role, roleTemplates, accessList } from '../../../models/rbac';
import { RoutingService } from '../../../services/routing.service';
import { ChipModule } from 'primeng/chip';
import { getState } from '@ngrx/signals';
import { AlertComponent } from '../../atoms/alert/alert.component';

@Component({
  selector: 'app-role-list',
  standalone: true,
  imports: [
    CardModule,
    ButtonModule,
    HeaderComponent,
    InputTextModule,
    NgIf,
    PaginatorModule,
    RouterOutlet,
    SidebarModule,
    TabMenuModule,
    TableModule,
    ToastModule,
    TableListActionsComponent,
    TableCaptionComponent,
    MaskComponent,
    ChipModule,
    NgClass,
    AlertComponent,
  ],
  templateUrl: './role-list.component.html',
  styleUrl: './role-list.component.scss',
})
export class RoleListComponent extends BaseListComponent<Role> {
  readonly store = inject(RoleStore);
  override sidebarId = 'role-administration';

  public roleTemplates = roleTemplates;
  public availableTemplates: Role[] = [];
  public availableTemplateKeys: string[] = [];
  public accessList = accessList;

  constructor(
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );

    this.store.loadAllItemsByPromise();
    effect(() => {
      const roleState = getState(this.store);
      this.availableTemplates = this.store.availableTemplates();
      this.availableTemplateKeys = this.availableTemplates.map(
        template => template.key || ''
      );
    });
  }

  addRole(template: Role) {
    this.store.addItem(template);
  }
}
